import isNil from 'lodash/isNil';

const STATE_STALENESS_PERIOD = 15 * 60 * 1000; // 15 minutes

const STATE_STALENESS_PERIOD_ONE_DAY = 24 * 60 * 60 * 1000; //once a day

export function isStateStale(lastUpdated) {
  return !lastUpdated || Date.now() - lastUpdated > STATE_STALENESS_PERIOD;
}

export const isStateOneDayOld = (lastUpdated) => {
  return isNil(lastUpdated) || Date.now() - lastUpdated > STATE_STALENESS_PERIOD_ONE_DAY;
};
